export const REQUEST = {
  idle: 'idle',
  pending: 'pending',
};
